"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactSlick = _interopRequireDefault(require("react-slick"));

var _reactRouterDom = require("react-router-dom");

var _reactResponsive = require("react-responsive");

var _reactIntl = require("react-intl");

var _helpers = require("../../../../../../lib/helpers");

var _Icon = _interopRequireDefault(require("../../../../../Icon"));

var _StyledLayout = require("../../../../../StyledLayout");

var _Elements = require("../../../../Elements");

var _ImageLayout = _interopRequireDefault(require("../../../Moodie/components/Grid/ImageLayout"));

var _Elements2 = require("./Elements");

var _CarouselArrow = require("../../../../common/components/CarouselArrow");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Gallery = function Gallery(_ref) {
  var _gallery$photos3, _gallery$photos3$edge, _gallery$photos7, _gallery$photos7$edge;

  var folders = _ref.folders,
      publicUrl = _ref.publicUrl,
      colour = _ref.colour,
      isTypeTheme = _ref.isTypeTheme,
      vh1 = _ref.vh1,
      webpSupported = _ref.webpSupported;
  var history = (0, _reactRouterDom.useHistory)();

  var _useParams = (0, _reactRouterDom.useParams)(),
      legacyId = _useParams.legacyId;

  var _useState = (0, _react.useState)(0),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      sliderIndex = _useState2[0],
      setSliderIndex = _useState2[1];

  var _useState3 = (0, _react.useState)(0),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      sliderHeight = _useState4[0],
      setSliderHeight = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      showMore = _useState6[0],
      setShowMore = _useState6[1];

  var sliderRef = (0, _react.useRef)(null);
  var sliderBoxRef = (0, _react.useRef)(null);
  var isTabletPortrait = (0, _reactResponsive.useMediaQuery)({
    query: '(min-width: 768px)'
  });
  var isMobileLandscape = (0, _reactResponsive.useMediaQuery)({
    query: '(min-width: 667px)'
  });

  var _useState7 = (0, _react.useState)(false),
      _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
      arrowRightPressed = _useState8[0],
      setArrowRightPressed = _useState8[1];

  var gallery = folders.find(function (folder) {
    return (folder === null || folder === void 0 ? void 0 : folder.id) === legacyId;
  });
  var notNullFolders = folders.filter(function (d) {
    return d;
  });
  var maxFolderPhotosLength = notNullFolders.reduce(function (acc, cur) {
    var _cur$photos, _cur$photos$edges, _cur$photos2, _cur$photos2$edges;

    return (cur === null || cur === void 0 ? void 0 : (_cur$photos = cur.photos) === null || _cur$photos === void 0 ? void 0 : (_cur$photos$edges = _cur$photos.edges) === null || _cur$photos$edges === void 0 ? void 0 : _cur$photos$edges.length) > acc ? cur === null || cur === void 0 ? void 0 : (_cur$photos2 = cur.photos) === null || _cur$photos2 === void 0 ? void 0 : (_cur$photos2$edges = _cur$photos2.edges) === null || _cur$photos2$edges === void 0 ? void 0 : _cur$photos2$edges.length : acc;
  }, 0);
  var currentGalleryIndex = notNullFolders.findIndex(function (item) {
    return item.id === legacyId;
  }); // eslint-disable-next-line max-len

  var nextGalleryId = notNullFolders.length - 1 > currentGalleryIndex ? notNullFolders[currentGalleryIndex + 1].id : undefined;
  var prevGalleryId = currentGalleryIndex !== 0 ? notNullFolders[currentGalleryIndex - 1].id : undefined;
  var sliderGallery = (0, _react.useMemo)(function () {
    var _gallery$photos, _gallery$photos$edges, _tempGallery$photos;

    var currentGalleryLength = gallery === null || gallery === void 0 ? void 0 : (_gallery$photos = gallery.photos) === null || _gallery$photos === void 0 ? void 0 : (_gallery$photos$edges = _gallery$photos.edges) === null || _gallery$photos$edges === void 0 ? void 0 : _gallery$photos$edges.length;
    var tempGallery = JSON.parse(JSON.stringify(gallery));
    var photos = tempGallery === null || tempGallery === void 0 ? void 0 : (_tempGallery$photos = tempGallery.photos) === null || _tempGallery$photos === void 0 ? void 0 : _tempGallery$photos.edges;

    if (maxFolderPhotosLength > currentGalleryLength) {
      var _tempGallery$photos2;

      var newArray = new Array(maxFolderPhotosLength - currentGalleryLength).fill(null);
      photos = photos.concat(newArray);

      if (tempGallery !== null && tempGallery !== void 0 && (_tempGallery$photos2 = tempGallery.photos) !== null && _tempGallery$photos2 !== void 0 && _tempGallery$photos2.edges) {
        tempGallery.photos.edges = photos;
      }
    }

    return tempGallery;
  }, [gallery]);
  (0, _react.useEffect)(function () {
    var _sliderBoxRef$current;

    if (sliderBoxRef !== null && sliderBoxRef !== void 0 && (_sliderBoxRef$current = sliderBoxRef.current) !== null && _sliderBoxRef$current !== void 0 && _sliderBoxRef$current.clientHeight) setSliderHeight(sliderBoxRef.current.clientHeight);
  }, []);
  (0, _react.useEffect)(function () {
    var _sliderRef$current;

    // eslint-disable-next-line no-unused-expressions
    sliderRef === null || sliderRef === void 0 ? void 0 : (_sliderRef$current = sliderRef.current) === null || _sliderRef$current === void 0 ? void 0 : _sliderRef$current.slickGoTo(0);
    setSliderIndex(0);
  }, [legacyId]);
  (0, _react.useEffect)(function () {
    var _sliderBoxRef$current2, _sliderBoxRef$current3;

    // eslint-disable-next-line no-unused-expressions
    sliderBoxRef === null || sliderBoxRef === void 0 ? void 0 : (_sliderBoxRef$current2 = sliderBoxRef.current) === null || _sliderBoxRef$current2 === void 0 ? void 0 : (_sliderBoxRef$current3 = _sliderBoxRef$current2.focus) === null || _sliderBoxRef$current3 === void 0 ? void 0 : _sliderBoxRef$current3.call(_sliderBoxRef$current2);
  }, []);
  (0, _react.useEffect)(function () {
    if (arrowRightPressed) {
      var _gallery$photos2, _gallery$photos2$edge;

      if (sliderIndex === ((_gallery$photos2 = gallery.photos) === null || _gallery$photos2 === void 0 ? void 0 : (_gallery$photos2$edge = _gallery$photos2.edges) === null || _gallery$photos2$edge === void 0 ? void 0 : _gallery$photos2$edge.length) - 1 && nextGalleryId) {
        history.push("".concat(publicUrl, "/gallery/").concat(nextGalleryId));
      } else {
        var _sliderRef$current2;

        // eslint-disable-next-line no-unused-expressions
        sliderRef === null || sliderRef === void 0 ? void 0 : (_sliderRef$current2 = sliderRef.current) === null || _sliderRef$current2 === void 0 ? void 0 : _sliderRef$current2.slickNext();
      }

      setArrowRightPressed(false);
    }
  }, [arrowRightPressed]);
  if (!gallery) return null;

  var keyDownHandler = function keyDownHandler(event) {
    var _sliderRef$current3;

    switch (event.code) {
      case 'ArrowRight':
        setArrowRightPressed(true);
        break;

      case 'ArrowLeft':
        // eslint-disable-next-line no-unused-expressions
        sliderRef === null || sliderRef === void 0 ? void 0 : (_sliderRef$current3 = sliderRef.current) === null || _sliderRef$current3 === void 0 ? void 0 : _sliderRef$current3.slickPrev();
        break;

      default:
        break;
    }
  };

  (0, _react.useEffect)(function () {
    window.addEventListener('keydown', keyDownHandler);
    return function () {
      window.removeEventListener('keydown', keyDownHandler);
    };
  }, []);
  var gridLayoutPhotos = (_gallery$photos3 = gallery.photos) === null || _gallery$photos3 === void 0 ? void 0 : (_gallery$photos3$edge = _gallery$photos3.edges) === null || _gallery$photos3$edge === void 0 ? void 0 : _gallery$photos3$edge.reduce(function (acc, cur) {
    var _cur$node, _cur$node2, _cur$node3;

    var temp = {};
    temp.height = cur === null || cur === void 0 ? void 0 : (_cur$node = cur.node) === null || _cur$node === void 0 ? void 0 : _cur$node.height;
    temp.width = cur === null || cur === void 0 ? void 0 : (_cur$node2 = cur.node) === null || _cur$node2 === void 0 ? void 0 : _cur$node2.width;
    temp.url = cur === null || cur === void 0 ? void 0 : (_cur$node3 = cur.node) === null || _cur$node3 === void 0 ? void 0 : _cur$node3.images[0].url;
    return acc.concat(temp);
  }, []);

  var renderClipText = function renderClipText() {
    var isMobile = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return /*#__PURE__*/_react["default"].createElement(_Elements2.ClipTextBox, {
      mb: "sm",
      showMore: showMore,
      style: {
        width: isMobile ? 'calc(100% + 200px)' : '100%'
      }
    }, /*#__PURE__*/_react["default"].createElement(_Elements2.ClipPlaceholder, null), /*#__PURE__*/_react["default"].createElement(_Elements2.ClipTextContent, {
      portfolioForeground1: true,
      small: true
    }, gallery.description), !showMore && /*#__PURE__*/_react["default"].createElement(_Elements2.ClipTextMore, {
      portfolioFontFamily: true,
      portfolioForeground1: true,
      onClick: function onClick() {
        setShowMore(true);
      }
    }, "...\xA0", /*#__PURE__*/_react["default"].createElement(_Elements.PortfolioParagraph, {
      portfolioForeground1: true,
      underline: true,
      small: true,
      as: "span"
    }, "show more")));
  };

  var renderNextArrow = function renderNextArrow() {
    var _gallery$photos4, _gallery$photos4$edge, _gallery$photos5, _gallery$photos5$edge;

    if (sliderIndex > ((_gallery$photos4 = gallery.photos) === null || _gallery$photos4 === void 0 ? void 0 : (_gallery$photos4$edge = _gallery$photos4.edges) === null || _gallery$photos4$edge === void 0 ? void 0 : _gallery$photos4$edge.length) - 1) {
      return null;
    }

    return sliderIndex === ((_gallery$photos5 = gallery.photos) === null || _gallery$photos5 === void 0 ? void 0 : (_gallery$photos5$edge = _gallery$photos5.edges) === null || _gallery$photos5$edge === void 0 ? void 0 : _gallery$photos5$edge.length) - 1 ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, nextGalleryId ? /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
      to: "".concat(publicUrl, "/gallery/").concat(nextGalleryId)
    }, /*#__PURE__*/_react["default"].createElement(_CarouselArrow.NextArrow, {
      withText: true,
      colour: colour,
      offset: 48
    })) : null) : /*#__PURE__*/_react["default"].createElement(_CarouselArrow.NextArrow, {
      colour: colour,
      offset: 48
    });
  };

  var settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: sliderIndex === 0 ? null : /*#__PURE__*/_react["default"].createElement(_CarouselArrow.PrevArrow, {
      colour: colour,
      offset: 48
    }),
    nextArrow: renderNextArrow()
  };

  if (isTabletPortrait) {
    var _sliderGallery$photos, _sliderGallery$photos2;

    return /*#__PURE__*/_react["default"].createElement(_Elements2.GalleryBox, {
      flex: true,
      column: true,
      isTabletPortrait: isTabletPortrait,
      isTypeTheme: isTypeTheme
    }, /*#__PURE__*/_react["default"].createElement(_Elements2.DesktopGalleryCaptionBox, {
      flex: true,
      align: "center",
      justify: "center",
      column: true
    }, /*#__PURE__*/_react["default"].createElement(_Elements2.GalleryTitle, {
      portfolioForeground1: true,
      bold: true,
      mb: "xs"
    }, gallery.name), gallery.description && renderClipText()), /*#__PURE__*/_react["default"].createElement(_Elements2.GallerySliderBox, {
      ref: sliderBoxRef,
      hasDescription: !!gallery.description,
      isTypeTheme: isTypeTheme
    }, /*#__PURE__*/_react["default"].createElement(_reactSlick["default"], (0, _extends2["default"])({}, settings, {
      afterChange: function afterChange(index) {
        setSliderIndex(index);
      },
      ref: sliderRef
    }), (_sliderGallery$photos = sliderGallery.photos) === null || _sliderGallery$photos === void 0 ? void 0 : (_sliderGallery$photos2 = _sliderGallery$photos.edges) === null || _sliderGallery$photos2 === void 0 ? void 0 : _sliderGallery$photos2.map(function (photo, idx) {
      var _gallery$photos6, _gallery$photos6$edge, _photo$node, _photo$node2, _photo$node3, _photo$node4, _photo$node5, _photo$node6, _photo$node7, _photo$node8, _photo$node9;

      var isLastSlide = idx === (gallery === null || gallery === void 0 ? void 0 : (_gallery$photos6 = gallery.photos) === null || _gallery$photos6 === void 0 ? void 0 : (_gallery$photos6$edge = _gallery$photos6.edges) === null || _gallery$photos6$edge === void 0 ? void 0 : _gallery$photos6$edge.length) - 1;
      var portraitImageWidth = sliderHeight * (photo === null || photo === void 0 ? void 0 : (_photo$node = photo.node) === null || _photo$node === void 0 ? void 0 : _photo$node.width) / (photo === null || photo === void 0 ? void 0 : (_photo$node2 = photo.node) === null || _photo$node2 === void 0 ? void 0 : _photo$node2.height);
      return /*#__PURE__*/_react["default"].createElement(_Elements2.GallerySliderItem, {
        flex: true,
        align: "center",
        justify: "center",
        key: photo === null || photo === void 0 ? void 0 : (_photo$node3 = photo.node) === null || _photo$node3 === void 0 ? void 0 : _photo$node3.legacyId
      }, (photo === null || photo === void 0 ? void 0 : (_photo$node4 = photo.node) === null || _photo$node4 === void 0 ? void 0 : _photo$node4.width) >= (photo === null || photo === void 0 ? void 0 : (_photo$node5 = photo.node) === null || _photo$node5 === void 0 ? void 0 : _photo$node5.height) && /*#__PURE__*/_react["default"].createElement(_Elements2.LandscapeImageWrapper, {
        lastItem: isLastSlide
      }, /*#__PURE__*/_react["default"].createElement(_Elements2.Image, {
        alt: "",
        onContextMenu: function onContextMenu(e) {
          return e.preventDefault();
        },
        src: (0, _helpers.getImageByFormat)(photo === null || photo === void 0 ? void 0 : (_photo$node6 = photo.node) === null || _photo$node6 === void 0 ? void 0 : _photo$node6.images[0], webpSupported)
      })), (photo === null || photo === void 0 ? void 0 : (_photo$node7 = photo.node) === null || _photo$node7 === void 0 ? void 0 : _photo$node7.width) < (photo === null || photo === void 0 ? void 0 : (_photo$node8 = photo.node) === null || _photo$node8 === void 0 ? void 0 : _photo$node8.height) && /*#__PURE__*/_react["default"].createElement(_Elements2.PortraitImageWrapper, {
        width: portraitImageWidth,
        lastItem: isLastSlide
      }, /*#__PURE__*/_react["default"].createElement(_Elements2.Image, {
        alt: "",
        onContextMenu: function onContextMenu(e) {
          return e.preventDefault();
        },
        src: (0, _helpers.getImageByFormat)(photo === null || photo === void 0 ? void 0 : (_photo$node9 = photo.node) === null || _photo$node9 === void 0 ? void 0 : _photo$node9.images[0], webpSupported)
      })));
    }))));
  }

  if (isMobileLandscape) {
    var layoutConfig = {
      columns: 2,
      columnWidth: 330,
      gutter: 8
    };
    return /*#__PURE__*/_react["default"].createElement(_Elements2.GalleryBox, {
      vh1: vh1
    }, /*#__PURE__*/_react["default"].createElement(_StyledLayout.Box, {
      flex: true,
      align: "center",
      justify: "center",
      column: true
    }, /*#__PURE__*/_react["default"].createElement(_Elements2.GalleryTitle, {
      portfolioForeground1: true,
      bold: true,
      mb: "xs"
    }, gallery.name), gallery.description && renderClipText(), /*#__PURE__*/_react["default"].createElement(_StyledLayout.Box, {
      flex: true,
      justify: "center"
    }, /*#__PURE__*/_react["default"].createElement(_ImageLayout["default"], (0, _extends2["default"])({}, layoutConfig, {
      photos: gridLayoutPhotos
    }))), /*#__PURE__*/_react["default"].createElement(_Elements2.MobilePortraitGalleryChangeBox, {
      flex: true,
      align: "center",
      justify: !prevGalleryId ? 'right' : 'space-between',
      px: "sm"
    }, prevGalleryId && /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
      to: "".concat(publicUrl, "/gallery/").concat(prevGalleryId),
      onClick: function onClick() {
        window.scrollTo(0, 0);
      }
    }, /*#__PURE__*/_react["default"].createElement(_StyledLayout.Box, {
      noWrap: true,
      flex: true,
      align: "center"
    }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      svg: "chevronLeft"
    }), /*#__PURE__*/_react["default"].createElement(_Elements.PortfolioParagraph, {
      portfolioForeground1: true
    }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "portfolio.theme.gallery.previous_gallery"
    })))), nextGalleryId && /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
      to: "".concat(publicUrl, "/gallery/").concat(nextGalleryId),
      onClick: function onClick() {
        window.scrollTo(0, 0);
      }
    }, /*#__PURE__*/_react["default"].createElement(_StyledLayout.Box, {
      noWrap: true,
      flex: true,
      align: "center"
    }, /*#__PURE__*/_react["default"].createElement(_Elements.PortfolioParagraph, {
      portfolioForeground1: true
    }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "portfolio.theme.gallery.next_gallery"
    })), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      svg: "chevronRight"
    }))))));
  }

  return /*#__PURE__*/_react["default"].createElement(_Elements2.GalleryBox, {
    vh1: vh1
  }, /*#__PURE__*/_react["default"].createElement(_StyledLayout.Box, {
    flex: true,
    align: "center",
    justify: "center",
    column: true
  }, /*#__PURE__*/_react["default"].createElement(_Elements.PortfolioParagraph, {
    large: true,
    portfolioForeground1: true,
    bold: true,
    mb: "xs"
  }, gallery.name), renderClipText(true), /*#__PURE__*/_react["default"].createElement(_Elements2.MobilePortraitGalleryBox, null, (_gallery$photos7 = gallery.photos) === null || _gallery$photos7 === void 0 ? void 0 : (_gallery$photos7$edge = _gallery$photos7.edges) === null || _gallery$photos7$edge === void 0 ? void 0 : _gallery$photos7$edge.map(function (photo) {
    var _photo$node10, _photo$node11;

    return /*#__PURE__*/_react["default"].createElement(_Elements2.MobilePortraitGalleryBox, {
      key: photo === null || photo === void 0 ? void 0 : (_photo$node10 = photo.node) === null || _photo$node10 === void 0 ? void 0 : _photo$node10.legacyId,
      mb: "xs"
    }, /*#__PURE__*/_react["default"].createElement(_Elements2.MobileImage, {
      alt: "",
      src: (0, _helpers.getImageByFormat)(photo === null || photo === void 0 ? void 0 : (_photo$node11 = photo.node) === null || _photo$node11 === void 0 ? void 0 : _photo$node11.images[0], webpSupported)
    }));
  })), /*#__PURE__*/_react["default"].createElement(_Elements2.MobilePortraitGalleryChangeBox, {
    flex: true,
    align: "center",
    justify: !prevGalleryId ? 'right' : 'space-between',
    px: "sm"
  }, prevGalleryId && /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
    to: "".concat(publicUrl, "/gallery/").concat(prevGalleryId),
    onClick: function onClick() {
      window.scrollTo(0, 0);
    }
  }, /*#__PURE__*/_react["default"].createElement(_StyledLayout.Box, {
    noWrap: true,
    flex: true,
    align: "center"
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    svg: "chevronLeft"
  }), /*#__PURE__*/_react["default"].createElement(_Elements.PortfolioParagraph, {
    portfolioForeground1: true
  }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "portfolio.theme.gallery.previous_gallery"
  })))), nextGalleryId && /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
    to: "".concat(publicUrl, "/gallery/").concat(nextGalleryId),
    onClick: function onClick() {
      window.scrollTo(0, 0);
    }
  }, /*#__PURE__*/_react["default"].createElement(_StyledLayout.Box, {
    noWrap: true,
    flex: true,
    align: "center"
  }, /*#__PURE__*/_react["default"].createElement(_Elements.PortfolioParagraph, {
    portfolioForeground1: true
  }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "portfolio.theme.gallery.next_gallery"
  })), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    svg: "chevronRight"
  }))))));
};

Gallery.defaultProps = {
  colour: '',
  vh1: null,
  webpSupported: false
};
Gallery.propTypes = {
  folders: _propTypes["default"].arrayOf(_propTypes["default"].shape()).isRequired,
  publicUrl: _propTypes["default"].string.isRequired,
  colour: _propTypes["default"].string,
  isTypeTheme: _propTypes["default"].bool.isRequired,
  vh1: _propTypes["default"].number,
  webpSupported: _propTypes["default"].bool
};
var _default = Gallery;
exports["default"] = _default;